import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Device } from '@era/locations-sdk';
import { RouterLink } from '@angular/router';
import { NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownItem } from '@ng-bootstrap/ng-bootstrap';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { MdmLinkPipe } from '../pipes/mdm-link.pipe';

@Component({
  selector: 'era-device-action-bar-ui',
  templateUrl: './device-action-bar.component.html',
  styleUrls: ['./device-action-bar.component.scss'],
  imports: [RouterLink, NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownItem, FaIconComponent, MdmLinkPipe],
})
export class DeviceActionBarComponent {
  @Input() public allowAssign = false;
  @Input() public allowSpare = false;
  @Input() public allowUnassign = false;
  @Input() public allowUnavailable = false;
  @Input() public allowHousekeeping = false;
  @Input() public allowStaff = false;
  @Input() public allowFrontDesk = false;
  @Input() public allowBar = false;
  @Input() public allowKiosk = false;

  @Input() public device: Device;
  @Input() public notesEnabled = false;
  @Input() public assignmentHistoryEnabled = false;

  @Output() public readonly openNotesModalEvent = new EventEmitter<object>();
  @Output() public readonly openAssignmentHistoryModalEvent = new EventEmitter<object>();

  openNotes() {
    this.openNotesModalEvent.emit({});
  }

  openAssignmentHistory() {
    this.openAssignmentHistoryModalEvent.emit({});
  }
}
